// <h2 style="color: red; margin-top: 0;">UWAGA!!! Formularz testowy, płatności nie są realizowane!</h2>

export default (account, idData) => `
  <div class="alert alert-fillup">

    <div class="row">
      <div class="col-sm-12 mb-2">
        <h4>Opłać podatek już teraz!</h4></br>
        <span><strong>Już teraz jesteś w stanie opłacić swój podatek bezpośrednio na własny wygenerowany mikrorachunek. Spróbuj, a przekonasz się jakie to proste!</strong> Wpisz poniżej kwotę podatku w PLN (np. 271,98), a następnie kliknij w przycisk opłać podatek. Zostaniesz przeniesiony do serwisu płatności internetowych, gdzie uzupełnisz pozostałe wymagane do płatności dane oraz wybierzesz dogodną dla Ciebie formę płatności.</span>
        </br>
      </div>
    </div>

    <div class="row mb-1">
    
      <div id="data-types" class="col-md-12 my-2">
        <div class="row justify-content-center">
          <div class="col-md-4"><button type="button" class="btn btn-default active btn-lg btn-block mb-2" data-type="person-data">Osoba</button></div>
          <div class="col-md-4"><button type="button" class="btn btn-default btn-lg btn-block mb-2" data-type="company-data">Firma</button></div>
        </div>
      </div>
      
      <div class="col-sm-12"><h5>Podstawowe dane</h5></div>
   
      <div id="person-data" class="col-md-8">
        <div class="row">
          <div class="form-group col-md-6">
            <label>Imię *</label>
            <input
              class="form-control "
              name="customer_first_name"
              type="text"
              maxlength="32"
              placeholder="np. Jan">
          </div>
        
          <div class="form-group col-md-6">
            <label>Nazwisko *</label>
            <input
              class="form-control "
              name="customer_last_name"
              type="text"
              maxlength="64"
              placeholder="np. Kowalski">
          </div>
        </div>
      </div>
   
      <div id="company-data" class="col-md-8 hide">
        <div class="row">
          <div class="form-group col-md-12">
            <label>Nazwa firmy *</label>
            <input
              class="form-control "
              name="company_name"
              type="text"
              maxlength="150"
              placeholder="np. fullUp Sp. z o.o.">
          </div>
        </div>
      </div>
    
      <div class="form-group col-md-4">
        <label>E-mail *</label>
        <input
          class="form-control "
          name="customer_email"
          type="email"
          placeholder="np. jan.kowalski@poczta.pl">
      </div>
      
      <div class="form-group col-md-4 id-data">
        <label></label>
        <input
          class="form-control "
          type="text"
          readonly>
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-sm-12"><h5>Adres</h5></div>
      
      <div class="form-group col-md-4">
        <label>Kraj *</label>
        <input type="text" class="form-control" placeholder="np. Polska" name="tax_country" value="Polska" maxlength="30">
      </div>
      
      <div class="form-group col-md-4">
        <label>Ulica / Miejscowość *</label>
        <input type="text" class="form-control" placeholder="np. Głogowska lub Jankowo" name="street" maxlength="50">
      </div>
      
      
      <div class="form-group col-md-2">
        <label>Nr budynku *</label>
        <input type="text" class="form-control" placeholder="np. 12" name="street_house_no">
      </div>
      
      <div class="form-group col-md-2">
        <label>Nr mieszkania</label>
        <input type="text" class="form-control" placeholder="np. 3" name="street_staircase_no">
      </div>
      
      <div class="form-group col-md-4">
        <label>Kod pocztowy *</label>
        <input type="text" class="form-control" placeholder="np. 61-100" name="postal_code" maxlength="10">
      </div>
      
      <div class="form-group col-md-4">
        <label>Miejscowość poczty *</label>
        <input type="text" class="form-control" placeholder="np. Poznań" name="city">
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-sm-12"><h5>Formularz</h5></div>
      
      <div class="form-group col-md-4">
        <label>Symbol formularza *</label>
        <select class="form-control " name="document_type">
            <option value="" selected>Wybierz z listy</option>
            <optgroup label="PIT">
                <option value="PIT-28">PIT-28</option>
                <option value="PIT-28S">PIT-28S</option>
                <option value="PIT-36">PIT-36</option>
                <option value="PIT-36L">PIT-36L</option>
                <option value="PIT-36S">PIT-36S</option>
                <option value="PIT-36LS">PIT-36LS</option>
                <option value="PIT-37">PIT-37</option>
                <option value="PIT-38">PIT-38</option>
                <option value="PIT-39">PIT-39</option>
                <option value="PIT-4R">PIT-4R</option>
                <option value="PPL">PPL</option>
                <option value="PIT-7">PIT-7</option>
                <option value="PIT-8AR">PIT-8AR</option>
                <option value="PIT-CFC">PIT-CFC</option>
            </optgroup>
            <optgroup label="VAT">
                <option value="VAT-7">VAT-7</option>
                <option value="VAT-7K">VAT-7K</option>
                <option value="VAT-7D">VAT-7D</option>
                <option value="VAT-8">VAT-8</option>
                <option value="VAT-9M">VAT-9M</option>
                <option value="VAT-10">VAT-10</option>
                <option value="VAT-12">VAT-12</option>
                <option value="VAT-14">VAT-14</option>
                <option value="VAP-1">VAP-1</option>
                <option value="VAI">VAI</option>
                <option value="VAT-IM">VAT-IM</option>
                <option value="VAT-In">VAT-In</option>
            </optgroup>
            <optgroup label="CIT">
                <option value="CIT-6R">CIT-6R</option>
                <option value="CIT-6AR">CIT-6AR</option>
                <option value="CIT-8">CIT-8</option>
                <option value="CIT-8A">CIT-8A</option>
                <option value="CIT-8B">CIT-8B</option>
                <option value="CIT-8AB">CIT-8AB</option>
                <option value="CIT-9R">CIT-9R</option>
                <option value="CIT-10Z">CIT-10Z</option>
                <option value="CIT-11R">CIT-11R</option>
                <option value="CIT-14">CIT-14</option>
                <option value="CIT-CFC">CIT-CFC</option>
            </optgroup>
        </select>
      </div>
    
      <div class="form-group col-md-2">
        <label>Rok *</label>
        <select class="form-control " name="period_year">
          <option value="15">2015</option>
          <option value="16">2016</option>
          <option value="17">2017</option>
          <option value="18">2018</option>
          <option value="19">2019</option>
          <option value="20">2020</option>
          <option value="21" selected>2021</option>
        </select>
      </div>
    
      <div class="form-group col-md-4">
        <label>Typ okresu *</label>
        <select class="form-control " name="period_type">
          <option value="R">Rok</option>
          <option value="P">Półrocze</option>
          <option value="K">Kwartał</option>
          <option value="M" selected>Miesiąc</option>
          <option value="D">Dekada</option>
          <option value="J">Dzień</option>
          <option value="0">Nie związane z okresem rozliczeniowym</option>
        </select>
      </div>
    
      <div class="form-group col-md-2">
        <label>Nr okresu *</label>
        <input type="text" class="form-control" placeholder="np. 07" name="period_no" maxlength="2">
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-sm-12"><h5>Płatność</h5></div>
      
      <div class="form-group col-md-4">
        <label>Mikrorachunek podatkowy</label>
        <input type="text" class="form-control" value="${account.raw}" name="tax_account" readonly>
      </div>
      
      <div class="form-group col-md-4">
        <label>Kwota podatku do opłacenia * **</label>
        <input type="text" class="form-control" placeholder="np. 100,00" name="tax_amount">
      </div>
    </div>
    
    <div class="row">
      <div class="col-sm-12">
        <span><i>Pamiętaj, aby na każdym etapie transakcji weryfikować zgodność danych oraz kwotę podatku.</i></span>
      </div>
      <div class="col-sm-12">
        <span><i>* Pola wymagane</i></span>
      </div>
      <div class="col-sm-12">
        <span><i>** Aby opłaci podatek szybkimi płatnościami Blue Media jego kwota nie może przekraczać 4300 zł.</i></span>
      </div>
    </div>

    <div class="row">
      <div class="btn-bar col-sm-12 mt-2">
        <div class="row">
          <div class="col-sm-5">
            <input type="hidden" name="bm" value="1">
            <input type="hidden" name="gph" value="">
            <button type="submit" class="btn btn-outline-violet-revert btn-outline-pay pay-tax">Opłać podatek on-line</button>
          </div>
        </div>
      </div>
    </div>

  </div>
`;

// <div class="col-sm-5">
//   <button type="submit" class="btn btn-outline-gray-revert btn-outline-pay fill-all">Wypełnij testowo</button>
// </div>